import SignOutForm from 'components/modules/auth/SignOutForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const SignOut = () => {
  return (
    <AuthCardLayout>
      <SignOutForm />
    </AuthCardLayout>
  );
};

export default SignOut;
